(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      /* querySelector('details-modal') returned only the FIRST of the header's two
         search modals (the desktop .header__search-slot pill and the icon-triggered
         one). That happened to be the right one purely because of DOM order, and the
         left cluster changed that order — close them all instead of depending on it. */
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((modal) => modal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* #10 — Open the desktop mega menus on HOVER / FOCUS of the parent nav item
     (the reference opens on hover, not click). Dawn ships them as
     <details class="mega-menu"> that toggle on summary click; we take over that
     toggle and add hover + focus open with an Esc close, keeping the keyboard
     path usable (Tab reveals it, focus-out / Esc closes). A short close grace
     bridges the small gap between the nav bar and the floating panel so it
     doesn't flicker. The chevron rotate + panel reveal are CSS (which already
     honour prefers-reduced-motion). */
  function initPfannerMegaHover() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      const details = menu.querySelector('details.mega-menu');
      if (!details) return;
      const summary = details.querySelector('summary');
      if (!summary) return;

      let closeTimer;
      const setOpen = (state) => {
        if (details.open === state) return;
        details.open = state;
        summary.setAttribute('aria-expanded', state ? 'true' : 'false');
      };
      const open = () => {
        window.clearTimeout(closeTimer);
        setOpen(true);
      };
      const scheduleClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) setOpen(false);
        }, 150);
      };

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('focusin', open);
      menu.addEventListener('focusout', scheduleClose);

      /* #22 — a mega parent is also a link (owner, 2026-08-12): clicking it goes
         straight to the collection, the same target as the panel's "Alle …" entry.
         The href is stamped on the summary by header-mega-menu.liquid, so the two
         can never point at different places.

         Guarded on `(hover: hover)`: without a hover-capable pointer there is no
         other way to open the panel, so on a touch device the tap must keep
         toggling it — an iPad in landscape is ≥990px and gets this same desktop
         nav. Modifier-clicks open a new tab, the way a real <a> would; a <summary>
         gives us none of that for free. */
      const megaHref = summary.dataset.megaHref;
      const pointerHovers = window.matchMedia('(hover: hover)');

      // Take over the native <details> toggle so a click / Enter on the summary
      // doesn't fight the hover/focus state.
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        window.clearTimeout(closeTimer);
        if (megaHref && pointerHovers.matches) {
          if (event.metaKey || event.ctrlKey) {
            window.open(megaHref, '_blank');
          } else {
            window.location.href = megaHref;
          }
          return;
        }
        setOpen(!details.open);
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          setOpen(false);
          summary.focus();
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    initPfannerMegaHover();
  } else {
    document.addEventListener('DOMContentLoaded', initPfannerMegaHover);
  }

  } catch(e) { console.error(e); }
})();
})();
